import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import { cn } from "../../lib/utils";

/**
 * Temporary rename as ATabs as the Tabs name is already taken by shadcn
 */
const ATabs = TabsPrimitive.Root;

const ATabsList = React.forwardRef<
	React.ElementRef<typeof TabsPrimitive.List>,
	React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
	<TabsPrimitive.List
		ref={ref}
		className={cn(
			"flex h-10 items-center text-slate-500 dark:bg-slate-800 dark:text-slate-400 border-b-2",
			className,
		)}
		{...props}
	/>
));
ATabsList.displayName = TabsPrimitive.List.displayName;

const ATabsTrigger = React.forwardRef<
	React.ElementRef<typeof TabsPrimitive.Trigger>,
	React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
	<TabsPrimitive.Trigger
		ref={ref}
		className={cn(
			"inline-flex items-center justify-center whitespace-nowrap px-0 py-2 text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-white data-[state=active]:text-slate-950 data-[state=active]:border-b-2 data-[state=active]:border-alta-light-green  : dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300 dark:data-[state=active]:bg-slate-950 dark:data-[state=active]:text-slate-50 mr-4 border-b-2 border-white",
			className,
		)}
		{...props}
	/>
));
ATabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const ATabsContent = React.forwardRef<
	React.ElementRef<typeof TabsPrimitive.Content>,
	React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
	<TabsPrimitive.Content
		ref={ref}
		className={cn(
			"mt-2 ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300",
			className,
		)}
		{...props}
	/>
));
ATabsContent.displayName = TabsPrimitive.Content.displayName;

export { ATabs, ATabsList, ATabsTrigger, ATabsContent };
